const RESULT_STYLE = (r) => {
  if (r === "SERIA IMPORTADO") return "text-green-700 font-bold";
  if (r.startsWith("PULADO")) return "text-[#E60000] font-bold";
  if (r.startsWith("IGNORADO")) return "text-zinc-500";
  if (r.includes("ARQUIVADO")) return "text-amber-700";
  return "text-zinc-600";
};

const fmtDt = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("pt-BR"); } catch { return iso; }
};

export default function SyncDiagnosticPanel({ diag }) {
  if (!diag) return null;
  const resumo = diag.resumo || {};
  return (
    <div className="border-2 border-black bg-white p-5 mb-6" data-testid="sync-diagnostic-panel">
      <div className="overline text-zinc-500 mb-1">DIAGNÓSTICO DO SYNC · {fmtDt(diag.gerado_em)}</div>

      <div className="border border-black bg-zinc-50 p-3 mb-4 text-sm font-semibold" data-testid="sync-diagnostic-conclusion">
        {diag.conclusao}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-2 text-xs mb-4">
        <div className="border border-zinc-300 p-2">
          <div className="overline text-zinc-400">CONEXÃO</div>
          <div className={`font-bold ${diag.connected ? "text-green-700" : "text-[#E60000]"}`}>
            {diag.connected ? "Conectado" : "DESCONECTADO"}
          </div>
        </div>
        <div className="border border-zinc-300 p-2">
          <div className="overline text-zinc-400">CONSULTA AO BLING</div>
          <div className={`font-mono font-bold ${diag.consulta_http_status === 200 ? "text-green-700" : "text-[#E60000]"}`}>
            {diag.consulta_http_status != null ? `HTTP ${diag.consulta_http_status}` : "—"}
          </div>
        </div>
        <div className="border border-zinc-300 p-2">
          <div className="overline text-zinc-400">ÚLTIMA SYNC PEDIDOS</div>
          <div className="font-mono">{fmtDt(diag.ultima_sync_pedidos)}</div>
        </div>
        <div className="border border-zinc-300 p-2">
          <div className="overline text-zinc-400">DATA DE CORTE</div>
          <div className="font-mono">{diag.data_corte_sync || "(sem)"}</div>
        </div>
        <div className="border border-zinc-300 p-2">
          <div className="overline text-zinc-400">PEDIDOS NA PÁG. 1</div>
          <div className="font-mono">{diag.pagina1_total ?? "—"}</div>
        </div>
      </div>

      {diag.ultimo_erro_sync && (
        <div className="border border-amber-600 bg-amber-50 text-amber-800 p-2 text-xs mb-4" data-testid="sync-diagnostic-sync-error">
          Último erro do sync: {diag.ultimo_erro_sync}{diag.ultimo_erro_sync_em ? ` (${fmtDt(diag.ultimo_erro_sync_em)})` : ""}
        </div>
      )}

      {diag.resposta_bling && (
        <div className="border border-zinc-400 bg-zinc-100 p-2 text-xs mb-4 font-mono break-all" data-testid="sync-diagnostic-bling-response">
          Resposta do Bling: {diag.resposta_bling}
        </div>
      )}

      {diag.ultimo_erro_token && (
        <div className="border border-[#E60000] bg-red-50 text-[#E60000] p-2 text-xs mb-4" data-testid="sync-diagnostic-token-error">
          Último erro de token: {diag.ultimo_erro_token}
        </div>
      )}

      {diag.resumo && (
        <div className="flex gap-2 flex-wrap text-[11px] mb-4" data-testid="sync-diagnostic-summary">
          <span className="border border-green-700 text-green-700 px-2 py-0.5 font-bold">Seriam importados: {resumo.seria_importado || 0}</span>
          <span className="border border-zinc-400 text-zinc-600 px-2 py-0.5">Já existem: {resumo.ja_existe || 0}</span>
          <span className="border border-zinc-400 text-zinc-500 px-2 py-0.5">Excluídos local: {resumo.excluido_local || 0}</span>
          <span className="border border-[#E60000] text-[#E60000] px-2 py-0.5">Pulados cancelados: {resumo.pulado_cancelado || 0}</span>
          <span className="border border-[#E60000] text-[#E60000] px-2 py-0.5">Pulados pré-corte: {resumo.pulado_pre_corte || 0}</span>
          {resumo.nao_verificado > 0 && <span className="border border-zinc-300 text-zinc-400 px-2 py-0.5">Não verificados: {resumo.nao_verificado}</span>}
        </div>
      )}

      {Array.isArray(diag.pedidos) && diag.pedidos.length > 0 && (
        <div className="overflow-x-auto max-h-96 overflow-y-auto border border-zinc-200">
          <table className="table table-compact text-xs" data-testid="sync-diagnostic-table">
            <thead><tr><th>Nº Bling</th><th>Data</th><th>Cliente</th><th>Situação</th><th>O que o sync faria</th></tr></thead>
            <tbody>
              {diag.pedidos.map((p, i) => (
                <tr key={`${p.numero}-${i}`}>
                  <td className="font-mono font-semibold">#{p.numero}</td>
                  <td className="font-mono">{p.data}</td>
                  <td>{p.contato || "—"}</td>
                  <td>{p.situacao || "—"}</td>
                  <td className={RESULT_STYLE(p.resultado || "")}>{p.resultado}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
